import { render } from "./WorksPage.vue?vue&type=template&id=f0878576&scoped=true"
import script from "./WorksPage.vue?vue&type=script&lang=js"
export * from "./WorksPage.vue?vue&type=script&lang=js"

import "./WorksPage.vue?vue&type=style&index=0&id=f0878576&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0878576"

export default script